/* @flow */
import * as React from 'react';
import { css } from 'linaria';

import Colors from '../constants/Colors';
import { Text, Card, Grid, GridCell, Image } from './core';
import MediaQueries from '../constants/MediaQueries';
import Responsive from '../constants/Responsive';

export type LogoType = {
  path?: string,
  image?: string,
  image2x?: string,
  imageWidth?: number,
  imageAlt: string,
};

function Logo({ logo }: { logo: LogoType }) {
  let { path, image, image2x, imageWidth, imageAlt } = logo;

  return (
    <GridCell size={Responsive('size6of12', 'size4of12', 'size3of12')} style={{ padding: 12 }}>
      <Card className={Styles.Card} to={path}>
        {image ? (
          <Image src={image} src2x={image2x} style={{ width: '100%', maxWidth: imageWidth }} />
        ) : (
          <Text size="28" weight="bold" color={Colors.Black}>
            {imageAlt}
          </Text>
        )}
      </Card>
    </GridCell>
  );
}

function LogoGrid({ logos }: { logos: Array<LogoType> }) {
  return (
    <Grid className={Styles.Grid} hAlign="center">
      {logos.map((logo, i) => {
        return <Logo logo={logo} key={i} />;
      })}
    </Grid>
  );
}

const Styles = {
  Grid: css`
    ${MediaQueries.Large} {
      margin-left: -12px;
      margin-right: -12px;
    }
  `,
  Card: css`
    align-items: center;
    height: 136px;
    justify-content: center;
    background-color: ${Colors.opacity('#F8F8F9', 0.5)};
    transition: all 200ms ease;
    &:hover {
      box-shadow: 0 12px 40px 0 rgba(0, 0, 0, 0.05);
      background-color: ${Colors.White};
    }
    ${MediaQueries.Medium} {
      height: 192px;
    }
    ${MediaQueries.Large} {
      height: 222px;
    }
  `,
};

export default LogoGrid;



// WEBPACK FOOTER //
// ./src/ui/components/LogoGrid.js